import { SET_WIS_VEHICLE } from '../actions/types';

export default function wisVehicle(state = {}, action) {
	if (!action.error) {
		const vehicleData = action.payload;

		switch (action.type) {
			case SET_WIS_VEHICLE:
				return vehicleData;

			default:
		}
	}

	return state;
}
